import React, { FunctionComponent } from 'react'
import { Divider, Heading, Modal, PaymentIcon, Text } from '@afterpaytouch/core'
import { CreditCard } from '@afterpaytouch/portal-api/consumer/account/creditcards/types'
import { useConsumerSizes } from '../../../../utils/responsive'
import { useCardIconName } from '../../../../utils/cardIconName'
import { maskCreditCardNumber } from '../../../../utils/card'
import { useTranslation } from 'next-i18next'
import { titleCase } from '@afterpay/utils'

const I18N_NAMESPACE = ['account']

interface BillingAddressModalProps {
  paymentMethod: CreditCard
  show: boolean
  handleClose: () => void
}

export const BillingAddressModal: FunctionComponent<BillingAddressModalProps> = ({ paymentMethod, show, handleClose }) => {
  const { sectionHeadingSize, textSize } = useConsumerSizes()
  const cardName = useCardIconName(paymentMethod?.cardBrand)
  const { t } = useTranslation(I18N_NAMESPACE)

  return (
    <Modal show={show} onBackdropClick={handleClose} onClose={handleClose} onEscapeKeyDown={handleClose}>
      <Modal.Header>
        <div className='text-center'>
          <Heading size={sectionHeadingSize}>{t('account:tab:payment-methods:modal:billingAddress:header')}</Heading>
        </div>
      </Modal.Header>
      <Divider kind='Hairline' />
      <Modal.Content>
        <div className='mt-2 flex justify-between'>
          <Text bold size={textSize}>
            {t('account:tab:payment-methods:modal:billingAddress:paymentMethod')}
          </Text>
          <div className='flex w-48 justify-between'>
            <PaymentIcon name={cardName} />
            <Text size={textSize} testNameSpace='billing-address-card-number'>
              {maskCreditCardNumber(paymentMethod?.maskedPan)}
            </Text>
            <Text size={textSize} color='Gray40' testNameSpace='billing-address-expiry-date'>
              {paymentMethod?.expiryDate}
            </Text>
          </div>
        </div>
        <div className='mt-4 flex justify-between'>
          <Text bold size={textSize}>
            {t('account:tab:payment-methods:modal:billingAddress:billingAddress')}
          </Text>
          <div className='w-48'>
            <Text testNameSpace='billing-address-address1'>{titleCase(paymentMethod?.billingAddress?.address1)}</Text>
            <Text testNameSpace='billing-address-address2'>{titleCase(paymentMethod?.billingAddress?.address2)}</Text>
            <Text testNameSpace='billing-address-suburbStatePostcode'>
              {titleCase(paymentMethod?.billingAddress?.suburb)}, {paymentMethod?.billingAddress?.state} {paymentMethod?.billingAddress?.postcode}
            </Text>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
